import { Route, Redirect, useLocation, RouteProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../hooks';

const PrivateRoute = ({ children, ...rest }: RouteProps) => {
    const { currentUser, fetchingCurrentUser } = useCurrentUser();
    const { t } = useTranslation('common');
    const redirect = currentUser === null && !fetchingCurrentUser ? true : false;
    const location = useLocation();

    //const from = redirect === false && location.pathname === '/' ? null : null;
    const from = location.pathname;

    return (
        redirect
            ? <Redirect to={{ pathname: `/${t('access.slug')}`, state: { from } }} />
            : <Route {...rest}>{children}</Route>
    );
}

export default PrivateRoute;
